import { ZealApiResponse } from "@zeal/common";

import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type { TGetContractorPaymentsResponse } from "./getContractorPayments.schema";

export const getContractorPayments = (axios: IAxiosInstance) => {
  return async (contractorID: string) => {
    const response = await axios.noRetry.get<
      ZealApiResponse<TGetContractorPaymentsResponse>
    >(`/api/getContractorPayments`, {
      params: { contractorID },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
